import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

export default [
    {
        path: '/invoices',
        name: routeType.INVOICES_DASHBOARD,
        component: () =>
            import(
                /* webpackChunkName: "invoice-dashboard" */ '@/pages/invoices/Dashboard.vue'
            ),
        meta,
        children: [
            {
                path: 'companies/:itemId',
                component: () =>
                    import(
                        /* webpackChunkName: "invoice-dashboard" */ '@/pages/invoices/Dashboard.vue'
                    ),
                props: true,
                name: 'company',
                meta,
            },
            {
                path: 'restaurants/:itemId',
                component: () =>
                    import(
                        /* webpackChunkName: "invoice-dashboard" */ '@/pages/invoices/Dashboard.vue'
                    ),
                props: true,
                name: 'restaurant',
                meta,
            },
        ],
    },
]
